import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';

export const ReportPredictiveStatesTileCont = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NoDataInfoCont = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  ${({ theme }: IThemeProvider) => `
       padding: ${theme.layout.spacing.deka} 0 ${theme.layout.spacing.centy};
       color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const NoDataInfo = styled(LabelRegularBoldM)`
  text-transform: uppercase;
  letter-spacing: 0.08em;
  ${({ theme }: IThemeProvider) => `
       color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const ContForTiles = styled.div`
  ${({ theme }: IThemeProvider) => `
      border-top: 1px solid ${theme.colors.neutral.primary[30]};
      padding: ${theme.layout.spacing.centy} 0;
  `};
`;
